/// <reference types="vite/client" />
import { SalesAgentInfo } from 'merchant-api/types';
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface SalesAgentInfoProps {
  isSalesAgentInfoLoading: boolean;
  salesAgentInfo: SalesAgentInfo | null | undefined;
  isSalesAgentInfoError: any;
  query: UseQueryResult<SalesAgentInfo>;
}

const getSalesAgentInfoData = () =>
  spiceroad
    .get<SalesAgentInfo>('/v1/sales-agent-info/current', {validateStatus: status => [200, 500].includes(status)})
    .then((res) => {
      if (res.status === 500) throw res;
      return res.data
    });

export const getSalesAgentInfoOpts = queryOptions<SalesAgentInfo>({
  queryKey: ['salesAgentInfo'],
  queryFn: getSalesAgentInfoData,
  retry: 0,
  throwOnError: false,
});

export function getSalesAgentInfo(): SalesAgentInfoProps {
  const query = useQuery(getSalesAgentInfoOpts);
  const { data, error, isLoading } = query;
  return {
    salesAgentInfo: isLoading
      ? undefined
      : Object.keys(data || {}).length
        ? data
        : null,
    isSalesAgentInfoLoading: isLoading,
    isSalesAgentInfoError: error,
    query,
  };
}

export default getSalesAgentInfo;
